import { Box, Container, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  CardVariant,
  WsCard,
  WsIconJDParse,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

const CreateClosureOptions = () => {
  const navigate = useNavigate();
  const location: any = useLocation();
  const [placementType, setPlacementType] = useState<string>('');
  const navigateToAddClosures = () =>
    navigate('/placements/add', { state: { placementType: placementType } });
  const navigateToConvertSubmission = () => navigate('/submissions');

  useEffect(() => {
    if (location.state && location.state.placementType) {
      setPlacementType(location.state.placementType);
    } else {
      setPlacementType('CONTRACT');
    }
  }, [location]);

  return (
    <Container
      style={{
        marginTop: '7%',
        marginBottom: '3%',
        backgroundColor: 'white',
        padding: '2%',
      }}
    >
      <Box textAlign="center">
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY900}>
          Add Placement
        </WsTypography>
        <Grid container marginTop="10%">
          <Grid xs={6}>
            <WsCard
              title="Add Manually"
              buttonText="Continue here"
              description="Fill in the placement details form manually."
              isButton={true}
              cardType={CardVariant.WITH_LIGHT_BG}
              middleComponent={<WsIconJDParse width={96} height={110} />}
              onClick={() => navigateToAddClosures()}
            />
          </Grid>
          <Grid xs={6}>
            <WsCard
              title="Convert Submission"
              buttonText="Convert Submission"
              description="Select candidate from the submissions."
              isButton={true}
              middleComponent={<WsIconJDParse width={96} height={110} />}
              onClick={() => navigateToConvertSubmission()}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CreateClosureOptions;
